import { Component, OnInit, inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-payment-status',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <div style="padding: 20px; text-align: center;">
      <div *ngIf="state === 'PENDING'">⏳ Verifying your payment authorization...</div>
      <div *ngIf="state === 'COMPLETED'">🎉 Payment of ₹{{ settlementAmount }} Successful!<br>
      A confirmation email has been sent to '{{instEmail}}'. Keep this receipt for your records.<br><br>
      <button class="btn btn-sm btn-warning" 
      (click)="curWindow.location.href='/dashboard/'+payrec_pgcode+'?orderId='+orderId+'&ppOrderId='+transactionId+'&status=SUCCESS&state='+state+'&amount='+settlementAmount+'&mode='+paymentMode">
      Download Receipt</button>&nbsp;&nbsp;
      <button class="btn btn-sm btn-info" (click)="curWindow.location.href='/dashboard/home'">Go to Dashboard</button>&nbsp;&nbsp;
      <button class="btn btn-sm btn-secondary" (click)="curWindow.close()">Close Window</button>
      </div>
      <div *ngIf="state === 'FAILED'">❌ Payment Failed. Please try checkout again.</div>
    </div>`
})

export class PaymentStatusComponent implements OnInit {
  orderId!: string;
  state: 'PENDING' | 'COMPLETED' | 'FAILED' = 'PENDING';
  settlementAmount: number = 0;
  instEmail: string = '';
  payrec_pgcode: any = '';
  transactionId: any = '';
  paymentMode: string = '';

  private document = inject(DOCUMENT);
  curWindow: any = this.document.defaultView;

  constructor(public dataService: DataService, private route: ActivatedRoute, private paymentService: AuthService) {
    //
  }

  ngOnInit() {
    this.payrec_pgcode = this.dataService.myEncrypt('payrec');

    let kycData: any = localStorage.getItem('kycData');
    if(kycData) {
      kycData = JSON.parse(kycData);
      this.instEmail = kycData?.institute?.email;
    }
    // Read the parameter matching your router configurations pattern path
    this.orderId = this.route.snapshot.paramMap.get('id') || '';
    
    if (this.orderId) {
      this.verifyPaymentResult();
    }
  }

  verifyPaymentResult() {
    this.paymentService.checkStatus(this.orderId).subscribe({
      next: (res) => {
        console.log(res);
        // Map states explicitly coming clean from node server payload mapping
        this.state = res.state; 
        this.settlementAmount = res.amount;
        this.transactionId = res.transactionId;
        this.paymentMode = res.paymentMode;

        // If the state is still pending when landing back, retry checking in 4 seconds
        if (this.state === 'PENDING') {
          setTimeout(() => this.verifyPaymentResult(), 4000);
        }
      },
      error: (err) => {
        console.error('Status check request failure:', err);
        this.state = 'FAILED';
      }
    });
  }
}
